const pointsTransfer = {
  namespaced: true,
  state: {
    csvDraft: null
  },
  mutations: {
    SET_CSV_DRAFT(state, payload) {
      state.csvDraft = payload;
    },
    CLEAR_CSV_DRAFT(state) {
      state.csvDraft = null;
    }
  }
};

export default pointsTransfer;
